
export interface SubContact {
    id: number;
    employee_type: string;
    first_name: string;
    last_name: string;
    email: string;
    pimary_phone_no: string;
    secondary_phone_no: string;
    user_role_id: number;
    display_role_name: string;
    profile_image: string;
    role_name: string;
}

export const mapSubContact = (data: any): SubContact => {
    if (!data) {
        throw new Error('Invalied SubContact type')
    }

    const subContact: SubContact = {

        id: data.id,
        employee_type: data.employee_type,
        first_name: data.first_name,
        last_name: data.last_name,
        email: data.email,
        pimary_phone_no: data.pimary_phone_no,
        secondary_phone_no: data.secondary_phone_no,
        profile_image: data.profile_image,
        user_role_id: data.user_role_id,
        display_role_name: data.display_role_name,
        role_name: data.role_name,

    }

    return subContact;

}

export const mapSubContacts = (data: any[]): SubContact[] => {
    if (!Array.isArray(data)) {
        throw new Error('Invalid SubContact data');
    }

    return data.map(mapSubContact);
};


export interface Professional {
    contactId: number;
    contactType: string;
    contactSubType: string;

    /*Personal Info*/
    id: number;
    first_name: string;
    last_name: string;
    email: string;
    mobile: string;
    landline: string;
    address: string;
    city: string;
    post_code: string;
    profile_image: string;

    /*sub contact*/
    subContact: SubContact[];

    /*Company info*/
    company_info_id: number;
    company_personal_email: string;
    company_personal_phone: string;
    company_name: string;
    company_regno: string;
    company_email: string;
    company_phone: string;
    company_address: string;
    company_city: string;
    company_post_code: string;
    company_landline: string;

    /*Role info*/
    user_role_info_id: number;
    user_role_id: number;
    display_role_name: string;
    role_name: string;

    /* Business info */
    business_id: number;
    business_name: string;
    business_email: string;
    business_phone: string;
    business_landline: string;
    business_address: string;
    business_city: string;
    business_post_code: string;
}

export const mapProfessional = (data: any): Professional => {
    if (!data) {
        throw new Error('Invalied professional type')
    }

    const professional: Professional = {
        contactId: data.contact_id,
        contactType: data.contact_type,
        contactSubType: data.contact_subtype,

        id: data.personalInfo?.id || 0,
        first_name: data.personalInfo?.first_name || '',
        last_name: data.personalInfo?.last_name || '',
        email: data.personalInfo?.email || '',
        mobile: data.personalInfo?.mobile || '',
        landline: data.personalInfo?.landline || '',
        address: data.personalInfo?.address || '',
        city: data.personalInfo?.city || '',
        post_code: data.personalInfo?.post_code || '',
        profile_image: data.personalInfo?.profile_image || '',

        subContact: mapSubContacts(data.subContact),

        company_info_id: data.CompanyInfo?.id || 0,
        company_personal_email: data.CompanyInfo?.personal_email || '',
        company_personal_phone: data.CompanyInfo?.personal_phone || '',
        company_name: data.CompanyInfo?.name || '',
        company_regno: data.CompanyInfo?.regno || '',
        company_email: data.CompanyInfo?.email || '',
        company_phone: data.CompanyInfo?.phone || '',
        company_address: data.CompanyInfo?.address || '',
        company_city: data.CompanyInfo?.city || '',
        company_post_code: data.CompanyInfo?.post_code || '',
        company_landline: data.CompanyInfo?.landline || '',

        user_role_info_id: data.userRoleInfo?.id || 0,
        user_role_id: data.userRoleInfo?.user_role_id || 0,
        display_role_name: data.userRoleInfo?.display_role_name || '',
        role_name: data.userRoleInfo?.role_name || '',

        business_id: data.businessInfo?.id || 0,
        business_name: data.businessInfo?.business_name || '',
        business_email: data.businessInfo?.business_email || '',
        business_phone: data.businessInfo?.business_phone || '',
        business_landline: data.businessInfo?.business_landline || '',
        business_address: data.businessInfo?.address || '',
        business_city: data.businessInfo?.city || '',
        business_post_code: data.businessInfo?.post_code || '',
    }

    return professional;
}

export const mapProfessionals = (data: any[]): Professional[] => {
    if (!Array.isArray(data)) {
        throw new Error('Invalid Professional data');
    }

    return data.map(mapProfessional);
};